import React from 'react';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';

import { getAPPID, getUrlName, isPreorder, isWHWPhase2Flag } from '../../../Helpers/index';
import CommonSection from '../../redesign/component/commonSection';
import CommonHelper from '../commonComp/commonHelper';

const DueToday = (props) => {
  const { dueTodayAmount, dueTodayList, plansReferenceData, isCartVisible, whwObj } = props;
  const { dueatshipment } = (plansReferenceData && plansReferenceData.miniCart) || {};
  const pageName = getUrlName(window.location.pathname);
  const nbsEnabledPages = ['cart', 'orderreview', 'confirmation'];
  const isNbsEnabledPage = pageName && getAPPID() === 'AAL' && nbsEnabledPages.includes(pageName);

  const showCartDetails = (e) => {
    if (e && e.keyCode === 9) {
      return;
    }
    props.showCartStatus(!isCartVisible);
  };

  return (
    <div>
      {dueTodayList && (
        <>
          {dueTodayAmount !== null && dueTodayAmount !== undefined && dueTodayAmount !== '' && (
            <CommonSection
              id="DueToday Info"
              leftValueText={isPreorder() ? dueatshipment : 'Due today'}
              rightValueText={`$${parseFloat(dueTodayAmount).toFixed(2)}`}
              className="headerStyle"
              iconPosition={isCartVisible}
              isCartVisible={isCartVisible}
              showIcon
              toggleCart={showCartDetails}
            />
          )}
          {isWHWPhase2Flag() &&
            whwObj &&
            whwObj?.length > 0 &&
            whwObj?.map((item) => (
              <CommonSection
                id="whw info"
                leftValueText={item?.featureDesc}
                rightValueText={
                  <>
                    {/* {parseFloat(item?.actualAmount)?.toFixed(2) !== parseFloat(item?.featurePrice)?.toFixed(2) && (
                      // <span>
                      //   <span className="actualPriceStrikeThrough">${parseFloat(item?.featurePrice)?.toFixed(2)}</span>&nbsp;
                      // </span>
                    )} */}
                    Included
                  </>
                }
                className="normalStyle"
                subTitle="After redemption"
              />
            ))}
          {isCartVisible && <CommonHelper {...props} />}

          {!isNbsEnabledPage && <Line type="secondary" surface="light" />}
        </>
      )}
    </div>
  );
};

DueToday.propTypes = {
  dueTodayAmount: PropTypes.number,
  dueTodayList: PropTypes.array,
  plansReferenceData: PropTypes.object,
  showCartStatus: PropTypes.func,
  isCartVisible: PropTypes.bool,
  whwObj: PropTypes.array,
};
export default DueToday;
